import {TrafficShapingStatus} from "../Models/TrafficShapingStatus";
import HttpService from "./HttpService";
import AddGroupToTrafficShaping from "../Requests/TrafficShaping/AddGroupToTrafficShaping"
import {TrafficShapingSettings} from "../Models/TrafficShapingSettings";

export class TrafficShapingService
{
    public static getStatus(): Promise<TrafficShapingStatus>
    {
        const url = '/TrafficShaping';
        return HttpService.get<TrafficShapingStatus>(url);
    }

    public static start(): Promise<void>
    {
        const url = '/TrafficShaping/Start';
        return HttpService.post<void>(url, {});
    }

    public static stop(): Promise<void>
    {
        const url = '/TrafficShaping/Stop';
        return HttpService.post<void>(url, {});
    }

    public static clear(): Promise<void>
    {
        const url = '/TrafficShaping/Clear';
        return HttpService.post<void>(url, {});
    }

    public static addGroup(groupId: string): Promise<void>
    {
        const url = '/TrafficShaping/AddGroup';
        const request: AddGroupToTrafficShaping = {
            groupId: groupId,
        };
        return HttpService.post<void>(url, request);
    }
    public static getSettings(): Promise<TrafficShapingSettings>
    {
        const url = '/TrafficShaping/Settings';
        return HttpService.get<TrafficShapingSettings>(url);
    }

    public static updateSettings(value: TrafficShapingSettings): Promise<void>
    {
        const url = '/TrafficShaping/Settings';
        return HttpService.put<void>(url, value);
    }
}